'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var envFallback = {};

var env = function env() {

  if (typeof window !== 'undefined') {

    return window;
  } else if (typeof global !== 'undefined') {

    return global;
  } else if (typeof WorkerGlobalScope !== 'undefined') {

    /* global WorkerGlobalScope */
    return WorkerGlobalScope;
  } else {

    return envFallback;
  }
};

exports.env = env;


//////////////////
// WEBPACK FOOTER
// ../node_modules/fedops-logger/dist/src/env.js
// module id = 6
// module chunks = 0